var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddParameter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "925 3276 94 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #556080;\n      }\n\n      .cls-2 {\n        fill: #c7cac7;\n      }\n\n      .cls-3 {\n        fill: #e7eced;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #ef806f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "controls_2_",
    "data-name": "controls (2)",
    transform: "translate(925 3274.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    className: "cls-1",
    d: "M6.491,64.132A1.49,1.49,0,0,1,5,62.64V2.991a1.491,1.491,0,0,1,2.982,0V62.64A1.49,1.49,0,0,1,6.491,64.132Z",
    transform: "translate(2.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    className: "cls-1",
    d: "M21.491,46.237A1.49,1.49,0,0,1,20,44.746V2.991a1.491,1.491,0,1,1,2.982,0V44.746A1.49,1.49,0,0,1,21.491,46.237Z",
    transform: "translate(9.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    className: "cls-1",
    d: "M36.491,28.342A1.49,1.49,0,0,1,35,26.851V2.991a1.491,1.491,0,1,1,2.982,0v23.86A1.49,1.49,0,0,1,36.491,28.342Z",
    transform: "translate(17.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    className: "cls-1",
    d: "M51.491,10.447A1.49,1.49,0,0,1,50,8.956V2.991a1.491,1.491,0,0,1,2.982,0V8.956A1.49,1.49,0,0,1,51.491,10.447Z",
    transform: "translate(24.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    className: "cls-1",
    d: "M21.491,62.377A1.49,1.49,0,0,1,20,60.886V42.991a1.491,1.491,0,0,1,2.982,0V60.886A1.49,1.49,0,0,1,21.491,62.377Z",
    transform: "translate(9.825 19.649)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    className: "cls-1",
    d: "M36.491,68.272A1.49,1.49,0,0,1,35,66.781V30.991a1.491,1.491,0,1,1,2.982,0V66.781A1.49,1.49,0,0,1,36.491,68.272Z",
    transform: "translate(17.193 13.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    className: "cls-1",
    d: "M51.491,74.167A1.49,1.49,0,0,1,50,72.675V18.991a1.491,1.491,0,0,1,2.982,0V72.675A1.49,1.49,0,0,1,51.491,74.167Z",
    transform: "translate(24.561 7.86)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    className: "cls-2",
    cx: 8.947,
    cy: 8.947,
    r: 8.947,
    transform: "translate(0 62.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    className: "cls-2",
    cx: 8.947,
    cy: 8.947,
    r: 8.947,
    transform: "translate(22.368 44.746)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    className: "cls-2",
    cx: 8.947,
    cy: 8.947,
    r: 8.947,
    transform: "translate(67.105 8.956)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    className: "cls-3",
    cx: 8.947,
    cy: 8.947,
    r: 8.947,
    transform: "translate(0 59.658)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    className: "cls-3",
    cx: 8.947,
    cy: 8.947,
    r: 8.947,
    transform: "translate(22.368 41.763)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    className: "cls-2",
    cx: 8.947,
    cy: 8.947,
    r: 8.947,
    transform: "translate(44.737 26.851)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    className: "cls-3",
    cx: 8.947,
    cy: 8.947,
    r: 8.947,
    transform: "translate(44.737 23.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    className: "cls-3",
    cx: 8.947,
    cy: 8.947,
    r: 8.947,
    transform: "translate(67.105 5.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    className: "cls-4",
    d: "M53.474,10.482H50.491a1.491,1.491,0,0,1,0-2.982h2.982a1.491,1.491,0,0,1,0,2.982Z",
    transform: "translate(24.07 2.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    className: "cls-4",
    d: "M38.474,22.482H35.491a1.491,1.491,0,1,1,0-2.982h2.982a1.491,1.491,0,0,1,0,2.982Z",
    transform: "translate(16.702 8.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    className: "cls-4",
    d: "M38.474,26.482H35.491a1.491,1.491,0,1,1,0-2.982h2.982a1.491,1.491,0,0,1,0,2.982Z",
    transform: "translate(16.702 10.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    className: "cls-4",
    d: "M23.474,34.482H20.491a1.491,1.491,0,1,1,0-2.982h2.982a1.491,1.491,0,1,1,0,2.982Z",
    transform: "translate(9.333 14.737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    className: "cls-4",
    d: "M23.474,38.482H20.491a1.491,1.491,0,1,1,0-2.982h2.982a1.491,1.491,0,1,1,0,2.982Z",
    transform: "translate(9.333 16.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    className: "cls-4",
    d: "M8.474,46.482H5.491a1.491,1.491,0,1,1,0-2.982H8.474a1.491,1.491,0,1,1,0,2.982Z",
    transform: "translate(1.965 20.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    className: "cls-4",
    d: "M8.474,50.482H5.491a1.491,1.491,0,1,1,0-2.982H8.474a1.491,1.491,0,1,1,0,2.982Z",
    transform: "translate(1.965 22.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    className: "cls-4",
    d: "M53.474,14.482H50.491a1.491,1.491,0,0,1,0-2.982h2.982a1.491,1.491,0,0,1,0,2.982Z",
    transform: "translate(24.07 4.912)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(-912 -771.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    className: "cls-5",
    cx: 18.5,
    cy: 18,
    rx: 18.5,
    ry: 18,
    transform: "translate(969 819)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    className: "cls-4",
    width: 25.488,
    height: 3.389,
    transform: "translate(995.381 847.173) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    className: "cls-4",
    width: 25.488,
    height: 3.389,
    transform: "translate(977.358 844.778) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddParameter);
export default __webpack_public_path__ + "static/media/add-parameter.18efc61150e951ef95741fe73f840e5d.svg";
export { ForwardRef as ReactComponent };